import { render, staticRenderFns } from "./ActiveRoom.vue?vue&type=template&id=3dbfd6a9&"
import script from "./ActiveRoom.vue?vue&type=script&lang=js&"
export * from "./ActiveRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports